var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcFacebookDesktop(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Path") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "rhp-home-forgot",
    transform: "translate(-878.000000, -231.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(750.000000, 221.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(128.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "facebook-icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.8981481,0 L1.10185185,0 C0.490740741,0 0,0.490740741 0,1.10185185 L0,18.8981481 C0,19.5092593 0.490740741,20 1.10185185,20 L10.6851852,20 L10.6851852,12.2592593 L8.07407407,12.2592593 L8.07407407,9.24074074 L10.6759259,9.24074074 L10.6759259,7.01851852 C10.6759259,4.43518519 12.25,3.02777778 14.5555556,3.02777778 C15.6574074,3.02777778 16.6111111,3.11111111 16.8888889,3.14814815 L16.8888889,5.85185185 L15.287037,5.85185185 C14.037037,5.85185185 13.787037,6.44444444 13.787037,7.32407407 L13.787037,9.25 L16.7777778,9.25 L16.3888889,12.2685185 L13.7962963,12.2685185 L13.7962963,20 L18.8888889,20 C19.5,20 19.9907407,19.5092593 19.9907407,18.8981481 L19.9907407,1.10185185 C20,0.490740741 19.5092593,0 18.8981481,0 Z",
    id: "Path"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFacebookDesktop);
export default __webpack_public_path__ + "static/media/icFacebookDesktop.2c35e9fe64bc7c764d60e27ec8ee535d.svg";
export { ForwardRef as ReactComponent };